import { render, staticRenderFns } from "./OrderChat.vue?vue&type=template&id=358fbfb8&scoped=true"
import script from "./OrderChat.vue?vue&type=script&lang=js"
export * from "./OrderChat.vue?vue&type=script&lang=js"
import style0 from "./OrderChat.vue?vue&type=style&index=0&id=358fbfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358fbfb8",
  null
  
)

export default component.exports